/* eslint-disable */
import * as util from "@/api/waajoForms";

const state = {};
const mutations = {};

const actions = {
  listWaajoForms({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.listWaajoForms(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  detailWaajoForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.detailWaajoForm(params.id).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  storedWaajoForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.storedWaajoForm(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  updateWaajoForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.updateWaajoForm(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  publishWaajoForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.publishWaajoForm(params.id).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  deactivateWaajoForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.deactivateWaajoForm(params.id).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  deleteWaajoForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.deleteWaajoForm(params.id).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  listWaajoFormResponses({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.listWaajoFormResponses(params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  detailWaajoFormResponse({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.detailWaajoFormResponse(params.id).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  statsWaajoFormResponses({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.statsWaajoFormResponses(params.formId).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  exportWaajoFormResponses({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.exportWaajoFormResponses(params.formId).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getWaajoFormNotificationConfig({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.getWaajoFormNotificationConfig(params.formId).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  updateWaajoFormNotificationConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      util.updateWaajoFormNotificationConfig(payload).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  uploadWaajoFormImage({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.uploadWaajoFormImage(params.formId, params.file).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  publicFormDefinition({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.getPublicFormDefinition(params.formId).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  submitPublicForm({ commit }, params) {
    return new Promise((resolve, reject) => {
      util.submitPublicForm(
        params.formId,
        params.answers,
        params.recaptchaToken
      ).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/waajoForms.js